export const GET_ROLES_BEGIN = "GET_ROLES_BEGIN";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE";
export const GET_ROLES_DISMISS_ERROR = "GET_ROLES_DISMISS_ERROR";


// WEBPACK FOOTER //
// ./src/features/admin/redux/constants.js